import { PoliciesService } from '@/backend/market'
import type { PolicyRepository } from '../../domain/repositories/PolicyRepository'
import type { PolicyEntity } from '@/shared/entities/PolicyEntity'

export class PolicyRepositoryImpl implements PolicyRepository {
  async getPolicies(): Promise<PolicyEntity[] | { error: true }> {
    try {
      const response = await PoliciesService.getBaseRolesAdmin()

      return response.items ?? []
    } catch {
      return { error: true }
    }
  }
}
